import { useRoutes } from "react-router";
import Inicio from "../Inicio/Inicio";
import Wrapper from "../Commons/Wrapper";
import PlanesCotizacion  from '../PlanesCotizacion/PlanesCotizacion';
import DetallesCotizacion from "../DetallesCotizacion/DetallesCotizacion";
import Mayor from "../Advertencias/Mayor";
import { ALGUIEN_MAS, BIENVENIDA, DATOS, SOLO_AM, SOLO_AM_AGREGAR } from "../Utils/Constantes";
import { Navigate } from 'react-router-dom';


export default function Pages(props) {
  let routes = useRoutes([
    { path: "/*", element: <Navigate to="/inicio" /> },
    { path: "/inicio", element: <Inicio isMobile={props.isMobile}/> },
    { path: "/bienvenida", element: <Wrapper isMobile={props.isMobile} componente={BIENVENIDA}/> }, 
    { path: "/datos-personales", element: <Wrapper isMobile={props.isMobile} componente={DATOS}/> },
    { path: "/datos/alguien-mas", element: <Wrapper isMobile={props.isMobile} componente={ALGUIEN_MAS}/> },
    { path: "/datos/alguien-mas/:continua", element: <Wrapper isMobile={props.isMobile} componente={ALGUIEN_MAS}/> },
    { path: "/datos/solo-alguien-mas", element: <Wrapper isMobile={props.isMobile} componente={SOLO_AM}/> },
    { path: "/datos/alguien-mas/agregar-mas", element: <Wrapper isMobile={props.isMobile} componente={SOLO_AM_AGREGAR}/> },
    { path: "/datos/alguien-mas/agregar-mas/:continua", element: <Wrapper isMobile={props.isMobile} componente={SOLO_AM_AGREGAR}/> },
    { path: "/mayor", element: <Mayor isMobile={props.isMobile}/> },    
    { path: "/cotizacion", element: <PlanesCotizacion isMobile={props.isMobile}/> },
    { path: "/detalles-cotizacion", element: <DetallesCotizacion isMobile={props.isMobile}/> },
    // ...
  ]);
  return routes;
};